import { type VariantProps } from "class-variance-authority";

import { cn } from "@/utils";
import { CircleCheck, Info, TriangleAlert } from "lucide-react";
import { HTMLAttributes, forwardRef } from "react";
import { toastTextVariants } from "./toast-text.variant";

export interface ToastTextProps
  extends HTMLAttributes<HTMLDivElement>,
    VariantProps<typeof toastTextVariants> {
  hasIcon?: boolean;
}

const ToastText = forwardRef<HTMLDivElement, ToastTextProps>(
  ({ className, variant, size, hasIcon, children, ...props }, ref) => {
    let Icon = Info;
    switch (variant) {
      case "danger":
        Icon = Info;
        break;
      case "warn":
        Icon = TriangleAlert;
        break;
      case "success":
        Icon = CircleCheck;
        break;

      default:
        break;
    }

    let iconClassName = "w-4 h-4";

    switch (size) {
      case "sm":
        iconClassName = "w-3 h-3";
        break;

      default:
        break;
    }
    return (
      <div
        className={cn(
          toastTextVariants({
            variant,
            size,
          }),
          className
        )}
        ref={ref}
        {...props}
      >
        {hasIcon && <Icon className={cn(iconClassName, "flex-shrink-0")} />}
        {children}
      </div>
    );
  }
);
ToastText.displayName = "ToastText";

export { ToastText };
